// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.create-session-dialog-content {
  display: flex;
  flex-direction: row;
  gap: var(--dialog-element-gap);
  justify-content: space-evenly;
}
`, "",{"version":3,"sources":["webpack://./src/ui/dialogs/create-session-dialog/CreateSessionDialog.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,6BAA6B;AAC/B","sourcesContent":[".create-session-dialog-content {\n  display: flex;\n  flex-direction: row;\n  gap: var(--dialog-element-gap);\n  justify-content: space-evenly;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
